import createRouter from 'router5';
import loggerPlugin from 'router5-plugin-logger';
import browserPlugin from 'router5-plugin-browser';

const routes = [
    { name: 'login', path: '/login' },
    { name: 'search', path: '/search' },
    { name: 'user', path: '/user/:id' },
    { name: 'customer', path: '/customer/:id' },
    { name: 'report', path: '/report/:reportName/:type' },
];

export default function configureRouter() {
    const router = createRouter(routes, {
        defaultRoute: 'search',
    });

    router.usePlugin(
        loggerPlugin,
        browserPlugin({
            useHash: true,
        }),
    );

    return router;
}
